module.exports = __webpack_public_path__ + "img/tenteki.0b77f01a.png";